module.exports = __webpack_public_path__ + "newstatic/img/adtype-banner.146b282.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/adtype-banner.png
// module id = moKM
// module chunks = 1